import React from "react";
import ReactDOM from "react-dom";
import Rout from "./Router";

import "bootswatch/dist/sketchy/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import "./index.css";

ReactDOM.render(<Rout />, document.getElementById("root"));
